import React, { memo, useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useIntl } from 'react-intl';

import { BabkaOauthSettings } from '../../../api/configurations/babkaLogin/types';
import { useFirstRender } from '../../../utils';
import { CopyIcon } from '../../ui';
import BottomRow from './components/BottomRow';
import { ClientLogo } from './components/ClientLogo';
import { ClientIDText, ClientIDWrapper, ContentWrapper, Title, TitleRow, Wrapper } from './style';

type Props = {
  client: BabkaOauthSettings;
};

const BabkaLoginCard = ({ client }: Props): JSX.Element => {
  const intl = useIntl();

  const [copied, setCopied] = useState<boolean>(false);
  const firstRender = useFirstRender();

  useEffect(() => {
    if (!firstRender && copied) {
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    }
  }, [copied]);

  return (
    <Wrapper>
      <ContentWrapper>
        <TitleRow>
          <ClientLogo url={client.icon_url} />
          <Title>{client.name}</Title>
        </TitleRow>
        <CopyToClipboard text={`${client.id}`}>
          <ClientIDWrapper onClick={() => setCopied(true)}>
            <ClientIDText>
              {intl.formatMessage({
                id: 'authorization.settings.oauth2.modal.connect.success.client-id'
              })}
              :
            </ClientIDText>
            &nbsp;{client.id}
            <CopyIcon disabled={copied} />
          </ClientIDWrapper>
        </CopyToClipboard>
      </ContentWrapper>

      <BottomRow isBabkaLogin client={client} />
    </Wrapper>
  );
};

export default memo(BabkaLoginCard);
